<template>
  <div>
    <navigation/>
    <div class="bt-main" style="padding-top: 60px;background-size: cover;height:900px;">
      <ul style="width: 100%">
        <li style="text-align: center;color:#fff;font-size: 34px;width:1200px;margin: 0 auto;">根据相关工作要求，本网站不再开展电子标识申请工作，请各企业前往国家市场监督管理总局电子营业执照亮照系统进行申请，申请链接如下：</li>
        <li style="text-align:center;margin-top: 20px;color:#ffffff;font-size: 40px;">
          电子营业执照亮照系统
          <p style="font-size: 30px;margin-top: 10px;" v-html="systemLink()"></p>
        </li>
      </ul>
      <div class="bt-title" style="background:rgba(0,0,0,0) none repeat scroll !important;font-size: 40px;margin-top: 100px;margin-bottom: 40px;">网上亮照告知书</div>
      <div class="bt-article" style="background:rgba(0,0,0,0) none repeat scroll !important;">
        《电子商务法》第十五条规定，电子商务经营者应当在其首页显著位置，持续公示营业执照信息、与其经营业务有关的行政许可信息、属于依照本法第十条规定的不需要办理市场主体登记情形等信息，或者上述信息的链接标识。前款规定的信息发生变更的，电子商务经营者应当及时更新公示信息。
      </div>
      <div class="bt-article" style="background:rgba(0,0,0,0) none repeat scroll !important;">
        链接标识（以下简称“网上亮照”）是指网络经营者依法在其经营网站(网页)上使用市场监管管理部门发放的、不易仿冒、具有显著特征、用于公示营业执照信息的图标，网上亮照公示是从事网络商品交易及有关服务行为的企业应当履行的法定义务。
      </div>
      <div class="bt-article" style="background:rgba(0,0,0,0) none repeat scroll !important;">
        网络经营企业实施网上亮照，有利于提升企业守法诚信经营的社会形象，有利于企业通过互联网的传播效应提升企业的影响力和竞争力，有利于构建公平竞争的网络市场环境。
      </div>
      <div class="bt-article" style="background:rgba(0,0,0,0) none repeat scroll !important;">
        {{clientTitle}}为广大网络经营企业实施网上亮照提供网络平台服务。
      </div>
    </div>
  </div>
</template>

<script>
import navigation from './navigation'

export default {
  name: 'newSitePage',
  components: {navigation},
  created () {
    localStorage.setItem('parentButton', 1)
  },
  data() {
    return {}
  },
  methods: {
    systemLink () {
      switch (location.hostname.split('.')[0]) {
        case 'gxlz':
          return `<a href="https://zzlz.gsxt.gov.cn/businessShow" style="color:rgb(217, 236, 255);text-decoration:underline;font-size: 30px;">https://zzlz.gsxt.gov.cn/businessShow</a>`
        default:
          return `<a href="/#/index" style="color:#ff3636b8;text-decoration:underline;font-size: 30px;">点击进入亮照系统</a>`
      }
    }
  }
}
</script>

<style>
@import '../assets/css/newStyle.css';
</style>



// WEBPACK FOOTER //
// src/components/newSitePage.vue